import React, { Component } from 'react'
import { Image, Linking, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import store from '../../../redux/store'
import { ensureProjectDataLoaded, PROJECT_DATA_CONTACTS } from '../../../utils/InitialLoad/projectDataLoader'
import PropTypes from 'prop-types'
import AppPopover from '../../UIComponents/ModalShell/AppPopover'

import UserPropertiesHeader from '../../UserDetailedView/UserProperties/UserPropertiesHeader'
import styles, { colors } from '../../styles/global'
import Button from '../../UIControls/Button'
import Icon from '../../Icon'
import ProjectHelper from '../../SettingsView/ProjectsSettings/ProjectHelper'
import { Picture } from '../../ContactsView/EditContact'
import ChangeTextFieldModal from '../../UIComponents/FloatModals/ChangeTextFieldModal'
import ChangeContactInfoModal from '../../UIComponents/FloatModals/ChangeContactInfoModal'
import HelperFunctions from '../../../utils/HelperFunctions'
import ImagePickerModal from '../../UIComponents/FloatModals/ImagePickerModal'
import {
    showConfirmPopup,
    setShowLimitedFeatureModal,
    setSelectedNavItem,
    setTriggerBotSpinner,
} from '../../../redux/actions'
import { buildBotSpinnerTrigger, endBotSpinnerWait } from '../../ChatsView/Utils/botSpinnerTrigger'
import { CONFIRM_POPUP_TRIGGER_DELETE_PROJECT_CONTACT } from '../../UIComponents/ConfirmPopup'
import URLsContacts, {
    URL_CONTACT_DETAILS_CHAT,
    URL_CONTACT_DETAILS_PROPERTIES,
} from '../../../URLSystem/Contacts/URLsContacts'
import ContactsHelper, { PHOTO_SIZE_300, PHOTO_SIZE_50 } from '../../ContactsView/Utils/ContactsHelper'
import FollowObject from '../../Followers/FollowObject'
import { FOLLOWER_CONTACTS_TYPE } from '../../Followers/FollowerConstants'
import {
    DV_TAB_CONTACT_CHAT,
    DV_TAB_CONTACT_PROPERTIES,
    DV_TAB_ROOT_CONTACTS,
} from '../../../utils/TabNavigationConstants'
import PrivacyButton from '../../UIComponents/FloatModals/PrivacyModal/PrivacyButton'
import { FEED_CONTACT_OBJECT_TYPE } from '../../Feeds/Utils/FeedsConstants'
import HighlightButton from '../../UIComponents/FloatModals/HighlightColorModal/HighlightButton'
import SharedHelper from '../../../utils/SharedHelper'
import { translate } from '../../../i18n/TranslationService'
import ObjectRevisionHistory from '../../NotesView/NotesDV/PropertiesView/ObjectRevisionHistory'
import AssistantProperty from '../../UIComponents/FloatModals/ChangeAssistantModal/AssistantProperty'
import ProjectPicker from '../../TaskDetailedView/Properties/ProjectPicker'
import {
    setProjectContactEmail,
    setProjectContactEmails,
    setProjectContactPhone,
    setProjectContactPicture,
    setProjectContactLinkedInUrl,
    enrichContactProfile,
} from '../../../utils/backends/Contacts/contactsFirestore'
import { resolveAssistantForProjectObject } from '../../AdminPanel/Assistants/assistantsHelper'
import ContactStatusProperty from '../../UIComponents/FloatModals/ChangeContactStatusModal/ContactStatusProperty'
import RichCreateTaskModal from '../../UIComponents/FloatModals/RichCreateTaskModal/RichCreateTaskModal'
import { popoverToSafePosition } from '../../../utils/HelperFunctions'

class ContactProperties extends Component {
    constructor(props) {
        super(props)

        const storeState = store.getState()

        this.state = {
            showInfoModal: false,
            showPictureModal: false,
            showEmailModal: false,
            showEmailsModal: false,
            showPhoneModal: false,
            showLinkedInModal: false,
            isEnriching: false,
            showAddTaskModal: false,
            loggedUser: storeState.loggedUser,
            selectedTab: storeState.selectedNavItem,
            projectContacts: storeState.projectContacts,
            smallScreen: storeState.smallScreen,
            smallScreenNavigation: storeState.smallScreenNavigation,
            unsubscribe: store.subscribe(this.updateState),
        }
    }

    componentDidMount() {
        this.writeBrowserURL()
        // AT-2386: the contact detailed view reads its contact out of `projectContacts[projectId]`,
        // which is filled on demand now. Ask for it; the store subscription above re-renders once
        // the first snapshot lands.
        ensureProjectDataLoaded(this.props.projectId, PROJECT_DATA_CONTACTS)
    }

    componentWillUnmount() {
        this.unmounted = true
        this.state.unsubscribe()
    }

    updateState = () => {
        const storeState = store.getState()

        this.setState({
            loggedUser: storeState.loggedUser,
            selectedTab: storeState.selectedNavItem,
            projectContacts: storeState.projectContacts,
            smallScreen: storeState.smallScreen,
            smallScreenNavigation: storeState.smallScreenNavigation,
        })
    }

    showModal = modal => {
        this.setState({ [modal]: true })
    }

    hideModal = modal => {
        this.setState({ [modal]: false })
    }

    changePropertyValue = (property, value) => {
        const { projectContacts } = this.state
        const { projectIndex, user, projectId } = this.props

        const contact = (projectContacts[projectId] || []).find(contact => contact.uid === user.uid)
        // The project's contacts may not have arrived yet; every branch below dereferences
        // `contact`, and the property editors re-render as soon as they do.
        if (!contact) return

        switch (property) {
            case 'info':
                ProjectHelper.setContactInfoInProject(
                    projectIndex,
                    contact,
                    contact.uid,
                    value.company.trim(),
                    contact.company,
                    value.role.trim(),
                    contact.role,
                    value.description.trim(),
                    contact.description
                )
                break
            case 'picture':
                setProjectContactPicture(projectId, user, user.uid, value)
                break
            case 'email':
                setProjectContactEmail(projectId, contact, user.uid, value.trim(), contact.email)
                break
            case 'emails':
                setProjectContactEmails(projectId, contact, user.uid, value, contact.email)
                break
            case 'phone':
                setProjectContactPhone(projectId, contact, user.uid, value.trim(), contact.phone)
                break
            case 'linkedInUrl':
                setProjectContactLinkedInUrl(projectId, contact, user.uid, value.trim())
                break
        }
    }

    deleteContact = () => {
        const { user, projectId } = this.props

        store.dispatch(
            showConfirmPopup({
                trigger: CONFIRM_POPUP_TRIGGER_DELETE_PROJECT_CONTACT,
                object: {
                    projectId: projectId,
                    contactId: user.uid,
                    contact: user,
                    navigation: DV_TAB_ROOT_CONTACTS,
                    headerText: 'Be careful, this action is permanent',
                    headerQuestion: 'Do you really want to delete this contact?',
                },
            })
        )
    }

    validateEmail = email => {
        return email === '' || HelperFunctions.isValidEmail(email)
    }

    validateEmails = emailList => {
        const emails = String(emailList || '')
            .split('\n')
            .map(email => email.trim())
            .filter(Boolean)
        return emails.every(email => HelperFunctions.isValidEmail(email))
    }

    getEmailsText = user => {
        const emails =
            Array.isArray(user.emails) && user.emails.length > 0 ? user.emails : user.email ? [user.email] : []
        return emails.join('\n')
    }

    // "Enrich profile": the assistant researches the person from public sources and fills the
    // card from inside the contact chat, asking there when it cannot tell two people apart. The
    // callable hosts the whole run (minutes), so the user is sent to the chat to watch it rather
    // than kept waiting on this tab.
    enrichContact = async () => {
        const { projectContacts, loggedUser } = this.state
        const { projectId, user: userProp } = this.props
        const contact = (projectContacts[projectId] || []).find(c => c.uid === userProp.uid)
        if (!contact) return

        // The run is billed as ordinary assistant usage; there is no flat fee, only "any Gold at all".
        if (!(loggedUser.gold > 0)) {
            store.dispatch(
                setShowLimitedFeatureModal({
                    title: translate('Not enough Gold'),
                    description: translate('Not enough Gold description'),
                })
            )
            return
        }

        const assistantId = resolveAssistantForProjectObject(projectId, contact.assistantId)?.uid || ''
        this.setState({ isEnriching: true })

        // The server posts the request comment and the answers into the chat tab, but only after the
        // callable has cold-started (often 10s+). The spinner trigger shows the "assistant is
        // preparing" placeholder there at once, so the tab is never an idle, empty-looking chat.
        store.dispatch([
            setTriggerBotSpinner(buildBotSpinnerTrigger(projectId, contact.uid)),
            setSelectedNavItem(DV_TAB_CONTACT_CHAT),
        ])
        URLsContacts.push(URL_CONTACT_DETAILS_CHAT, { projectId, userId: contact.uid }, projectId, contact.uid)

        try {
            const result = await enrichContactProfile(projectId, contact.uid, assistantId)
            if (result && result.error === 'insufficient_gold') {
                store.dispatch(
                    setShowLimitedFeatureModal({
                        title: translate('Not enough Gold'),
                        description: translate('Not enough Gold description'),
                    })
                )
            } else if (result && result.success === false) {
                alert(translate('Profile enrichment did not complete'))
            }
        } catch (error) {
            console.error('Contact enrichment failed:', error)
            // The browser gives up after 9 minutes while the server may keep running (it has 55), and
            // whatever it posts still reaches the chat; only a real failure is worth an alert.
            if (!/deadline-exceeded$/.test(String(error?.code || ''))) {
                alert(translate('Profile enrichment did not complete'))
            }
        } finally {
            // The callable returns once the run is over (or was refused). Either way nothing more is
            // coming, so the placeholder must not wait out its 5-minute safety timeout.
            endBotSpinnerWait(projectId, contact.uid)
        }
        if (!this.unmounted) this.setState({ isEnriching: false })
    }

    writeBrowserURL = () => {
        if (this.state.selectedTab === DV_TAB_CONTACT_PROPERTIES) {
            const { user, projectId } = this.props
            const data = { projectId: projectId, userId: user.uid }
            URLsContacts.push(URL_CONTACT_DETAILS_PROPERTIES, data, projectId, user.uid)
        }
    }

    render() {
        const {
            projectContacts,
            smallScreen: mobile,
            smallScreenNavigation: mobileNav,
            showInfoModal,
            showPictureModal,
            showEmailModal,
            showEmailsModal,
            showPhoneModal,
            showLinkedInModal,
            isEnriching,
            showAddTaskModal,
            loggedUser,
        } = this.state
        const { projectIndex, user: userProp, projectId } = this.props

        const user = projectContacts[projectId]?.find(contact => contact.uid === userProp.uid)
        const accessGranted = SharedHelper.accessGranted(loggedUser, projectId)

        if (user !== undefined) {
            const userRole = ProjectHelper.getUserRoleInProject(projectId, user.uid, user.role)
            const userCompany = ProjectHelper.getUserCompanyInProject(projectId, user.uid, user.company)
            const userDescription = ProjectHelper.getUserDescriptionInProject(
                projectId,
                user.uid,
                user.description,
                user.extendedDescription,
                false
            )
            const highlightColor = ProjectHelper.getUserHighlightInProject(projectIndex, user)
            const userPhoto50 = ContactsHelper.getContactPhotoURL(user, false, PHOTO_SIZE_50)
            const userPhoto300 = ContactsHelper.getContactPhotoURL(user, false, PHOTO_SIZE_300)
            user.hasStar = highlightColor

            const userInfo =
                !userRole && !userCompany
                    ? userDescription
                        ? userDescription
                        : ''
                    : `${userRole ? userRole : ''}${userRole && userCompany ? ' • ' : ''}${
                          userCompany ? userCompany : ''
                      }`

            const loggedUserIsCreator = loggedUser.uid === userProp.recorderUserId
            const loggedUserCanUpdateObject =
                loggedUserIsCreator || !ProjectHelper.checkIfLoggedUserIsNormalUserInGuide(projectId)
            const isGuide = !!ProjectHelper.getProjectById(projectId)?.parentTemplateId

            return (
                <View style={localStyles.container}>
                    <UserPropertiesHeader />

                    {/* Profile Header: Big photo + Info */}
                    <View style={[localStyles.profileHeader, mobile && localStyles.profileHeaderMobile]}>
                        <View style={localStyles.profilePhotoContainer}>
                            <AppPopover
                                content={
                                    <ImagePickerModal
                                        closePopover={() => this.hideModal('showPictureModal')}
                                        onSavePicture={value => this.changePropertyValue('picture', value)}
                                        picture={userPhoto300 !== '' ? userPhoto300 : undefined}
                                    />
                                }
                                onClickOutside={() => this.hideModal('showPictureModal')}
                                isOpen={showPictureModal}
                                position={['bottom', 'left', 'right', 'top']}
                                padding={4}
                                align={'end'}
                                contentLocation={mobile ? null : undefined}
                            >
                                <TouchableOpacity
                                    onPress={() => this.showModal('showPictureModal')}
                                    disabled={!accessGranted || !loggedUserCanUpdateObject}
                                >
                                    {userPhoto300 ? (
                                        <Image source={{ uri: userPhoto300 }} style={localStyles.profilePhoto} />
                                    ) : (
                                        <View style={[localStyles.profilePhoto, localStyles.profilePhotoPlaceholder]}>
                                            <Icon name={'user'} size={40} color={colors.Text03} />
                                        </View>
                                    )}
                                    {accessGranted && loggedUserCanUpdateObject && (
                                        <View style={localStyles.profilePhotoEditBadge}>
                                            <Icon name={'image'} size={14} color={'#fff'} />
                                        </View>
                                    )}
                                </TouchableOpacity>
                            </AppPopover>
                        </View>
                        <View style={localStyles.profileInfo}>
                            <View style={{ flex: 1 }}>
                                {userRole ? (
                                    <Text style={[styles.body1, { color: colors.Text03 }]} numberOfLines={1}>
                                        {userRole}
                                    </Text>
                                ) : null}
                                {userCompany ? (
                                    <Text style={[styles.body1, { color: colors.Text03 }]} numberOfLines={1}>
                                        {userCompany}
                                    </Text>
                                ) : null}
                                {userDescription ? (
                                    <Text
                                        style={[styles.body2, { color: colors.Text03, marginTop: 4 }]}
                                        numberOfLines={3}
                                    >
                                        {userDescription}
                                    </Text>
                                ) : null}
                                {!userRole && !userCompany && !userDescription && (
                                    <Text style={[styles.body2, { color: colors.Text03 }]}>
                                        {translate('No info available')}
                                    </Text>
                                )}
                            </View>
                        </View>
                        <View style={localStyles.profileActions}>
                            <AppPopover
                                content={
                                    <ChangeContactInfoModal
                                        projectId={projectId}
                                        closePopover={() => this.hideModal('showInfoModal')}
                                        onSaveData={value => this.changePropertyValue('info', value)}
                                        currentRole={userRole ? userRole : ''}
                                        currentCompany={userCompany ? userCompany : ''}
                                        currentDescription={userDescription ? userDescription : ''}
                                        disabled={!loggedUserCanUpdateObject}
                                    />
                                }
                                onClickOutside={() => this.hideModal('showInfoModal')}
                                isOpen={showInfoModal}
                                position={['bottom', 'left', 'right', 'top']}
                                padding={4}
                                align={'end'}
                                contentLocation={mobile ? null : undefined}
                            >
                                <Button
                                    icon={'edit-2'}
                                    type={'ghost'}
                                    onPress={() => this.showModal('showInfoModal')}
                                    disabled={!accessGranted || !loggedUserCanUpdateObject}
                                />
                            </AppPopover>
                            {!isGuide && (
                                <Button
                                    icon={'search'}
                                    title={isEnriching ? translate('Loading') : translate('Enrich profile')}
                                    type={'ghost'}
                                    onPress={this.enrichContact}
                                    disabled={!accessGranted || !loggedUserCanUpdateObject || isEnriching}
                                />
                            )}
                        </View>
                    </View>

                    <View style={[localStyles.properties, mobile ? localStyles.propertiesMobile : undefined]}>
                        <View style={{ flex: 1, marginRight: mobile ? 0 : 72 }}>
                            <View style={localStyles.propertyRow}>
                                <View style={[localStyles.propertyRowSection, localStyles.propertyRowLeft]}>
                                    <Icon
                                        name={'circle'}
                                        size={24}
                                        color={colors.Text03}
                                        style={{ marginHorizontal: 8 }}
                                    />
                                    <Text style={[styles.subtitle2, { color: colors.Text03 }]}>
                                        {translate('Project')}
                                    </Text>
                                </View>
                                <View style={[localStyles.propertyRowSection, localStyles.propertyRowRight]}>
                                    <ProjectPicker
                                        project={this.props.project}
                                        item={{ type: 'contact', data: { ...user, id: user.uid } }}
                                        disabled={!accessGranted || !loggedUserCanUpdateObject || isGuide}
                                    />
                                </View>
                            </View>

                            <View style={localStyles.linkedInContainer}>
                                <View style={localStyles.linkedInTopRow}>
                                    <View style={[localStyles.propertyRowSection, localStyles.propertyRowLeft]}>
                                        <Icon
                                            name={'link'}
                                            size={24}
                                            color={colors.Text03}
                                            style={{ marginHorizontal: 8 }}
                                        />
                                        <Text style={[styles.subtitle2, { color: colors.Text03 }]} numberOfLines={1}>
                                            {translate('LinkedIn URL')}
                                        </Text>
                                    </View>
                                    <View style={[localStyles.propertyRowSection, localStyles.propertyRowRight]}>
                                        <AppPopover
                                            content={
                                                <ChangeTextFieldModal
                                                    header={'Edit LinkedIn URL'}
                                                    subheader={'Type the LinkedIn profile URL'}
                                                    label={'LinkedIn URL'}
                                                    placeholder={'https://www.linkedin.com/in/...'}
                                                    closePopover={() => this.hideModal('showLinkedInModal')}
                                                    onSaveData={value => this.changePropertyValue('linkedInUrl', value)}
                                                    currentValue={user.linkedInUrl}
                                                />
                                            }
                                            onClickOutside={() => this.hideModal('showLinkedInModal')}
                                            isOpen={showLinkedInModal}
                                            position={['bottom', 'left', 'right', 'top']}
                                            padding={4}
                                            align={'end'}
                                            contentLocation={mobile ? null : undefined}
                                        >
                                            <Button
                                                icon={'edit-2'}
                                                type={'ghost'}
                                                onPress={() => this.showModal('showLinkedInModal')}
                                                disabled={!accessGranted || !loggedUserCanUpdateObject}
                                            />
                                        </AppPopover>
                                    </View>
                                </View>

                                {user.linkedInUrl !== '' && (
                                    <TouchableOpacity
                                        style={{ paddingLeft: 40, paddingRight: 8, paddingBottom: 8 }}
                                        onPress={() => {
                                            if (window) {
                                                window.open(user.linkedInUrl, '_blank')
                                            } else {
                                                Linking.openURL(user.linkedInUrl)
                                            }
                                        }}
                                    >
                                        <Text style={[styles.body1, { color: colors.Primary100 }]} numberOfLines={1}>
                                            {user.linkedInUrl}
                                        </Text>
                                    </TouchableOpacity>
                                )}
                            </View>

                            <View style={localStyles.propertyRow}>
                                <View style={[localStyles.propertyRowSection, localStyles.propertyRowLeft]}>
                                    <Icon
                                        name={'lock'}
                                        size={24}
                                        color={colors.Text03}
                                        style={{ marginHorizontal: 8 }}
                                    />
                                    <Text style={[styles.subtitle2, { color: colors.Text03 }]}>
                                        {translate('Privacy')}
                                    </Text>
                                </View>
                                <View style={[localStyles.propertyRowSection, localStyles.propertyRowRight]}>
                                    <PrivacyButton
                                        projectId={projectId}
                                        object={user}
                                        objectType={FEED_CONTACT_OBJECT_TYPE}
                                        disabled={!accessGranted || !loggedUserCanUpdateObject}
                                        shortcutText={'P'}
                                    />
                                </View>
                            </View>

                            <View style={localStyles.propertyRow}>
                                <View style={[localStyles.propertyRowSection, localStyles.propertyRowLeft]}>
                                    <Icon
                                        name={'phone'}
                                        size={24}
                                        color={colors.Text03}
                                        style={{ marginHorizontal: 8 }}
                                    />

                                    {mobileNav ? (
                                        <Text style={[styles.body1]} numberOfLines={1}>
                                            {user.phone === '' ? translate('Phone unknown') : user.phone}
                                        </Text>
                                    ) : (
                                        <Text style={[styles.subtitle2, { color: colors.Text03 }]} numberOfLines={1}>
                                            {translate('Phone')}
                                        </Text>
                                    )}
                                </View>
                                <View style={[localStyles.propertyRowSection, localStyles.propertyRowRight]}>
                                    {!mobileNav && (
                                        <Text style={[styles.body1, { marginRight: 8 }]} numberOfLines={1}>
                                            {user.phone === '' ? translate('Phone unknown') : user.phone}
                                        </Text>
                                    )}

                                    <AppPopover
                                        content={
                                            <ChangeTextFieldModal
                                                header={'Edit phone'}
                                                subheader={'Type the phone of this person'}
                                                label={'Phone'}
                                                placeholder={'Type the phone number'}
                                                closePopover={() => this.hideModal('showPhoneModal')}
                                                onSaveData={value => this.changePropertyValue('phone', value)}
                                                currentValue={user.phone}
                                            />
                                        }
                                        onClickOutside={() => this.hideModal('showPhoneModal')}
                                        isOpen={showPhoneModal}
                                        position={['bottom', 'left', 'right', 'top']}
                                        padding={4}
                                        align={'end'}
                                        contentLocation={mobile ? null : undefined}
                                    >
                                        <Button
                                            icon={'edit-2'}
                                            type={'ghost'}
                                            onPress={() => this.showModal('showPhoneModal')}
                                            disabled={!accessGranted || !loggedUserCanUpdateObject}
                                        />
                                    </AppPopover>
                                </View>
                            </View>
                            {accessGranted && (
                                <FollowObject
                                    projectId={projectId}
                                    followObjectsType={FOLLOWER_CONTACTS_TYPE}
                                    followObjectId={user.uid}
                                    loggedUserId={loggedUser.uid}
                                    object={user}
                                />
                            )}
                        </View>

                        <View style={{ flex: 1 }}>
                            <AssistantProperty
                                projectId={projectId}
                                assistantId={user.assistantId}
                                disabled={!accessGranted || !loggedUserCanUpdateObject}
                                objectId={user.uid}
                                objectType={'contacts'}
                            />
                            <ContactStatusProperty
                                projectId={projectId}
                                contactStatusId={user.contactStatusId}
                                disabled={!accessGranted || !loggedUserCanUpdateObject}
                                contact={user}
                            />
                            <View style={localStyles.propertyRow}>
                                <View style={[localStyles.propertyRowSection, localStyles.propertyRowLeft]}>
                                    <Icon
                                        name={'highlight'}
                                        size={24}
                                        color={colors.Text03}
                                        style={{ marginHorizontal: 8 }}
                                    />
                                    <Text style={[styles.subtitle2, { color: colors.Text03 }]}>
                                        {translate('Highlight')}
                                    </Text>
                                </View>
                                <View style={[localStyles.propertyRowSection, localStyles.propertyRowRight]}>
                                    <HighlightButton
                                        projectId={projectId}
                                        object={user}
                                        objectType={FEED_CONTACT_OBJECT_TYPE}
                                        shortcutText={'H'}
                                        disabled={!accessGranted || !loggedUserCanUpdateObject}
                                    />
                                </View>
                            </View>

                            <View style={localStyles.propertyRow}>
                                <View style={[localStyles.propertyRowSection, localStyles.propertyRowLeft]}>
                                    <Icon
                                        name={'mail'}
                                        size={24}
                                        color={colors.Text03}
                                        style={{ marginHorizontal: 8 }}
                                    />
                                    {mobileNav ? (
                                        <Text style={[styles.body1]} numberOfLines={1}>
                                            {this.getEmailsText(user) === ''
                                                ? translate('Email unknown')
                                                : this.getEmailsText(user)}
                                        </Text>
                                    ) : (
                                        <Text style={[styles.subtitle2, { color: colors.Text03 }]} numberOfLines={1}>
                                            {translate('Email addresses')}
                                        </Text>
                                    )}
                                </View>
                                <View style={[localStyles.propertyRowSection, localStyles.propertyRowRight]}>
                                    {!mobileNav && (
                                        <Text style={[styles.body1, { marginRight: 8, textAlign: 'right' }]}>
                                            {this.getEmailsText(user) === ''
                                                ? translate('Email unknown')
                                                : this.getEmailsText(user)}
                                        </Text>
                                    )}

                                    <AppPopover
                                        content={
                                            <ChangeTextFieldModal
                                                header={'Edit email addresses'}
                                                subheader={
                                                    'Type one email address per line. The first line is the primary email.'
                                                }
                                                label={'Email addresses'}
                                                placeholder={'Type one email address per line'}
                                                closePopover={() => this.hideModal('showEmailsModal')}
                                                onSaveData={value => this.changePropertyValue('emails', value)}
                                                currentValue={this.getEmailsText(user)}
                                                validateFunction={this.validateEmails}
                                                multiline={true}
                                                numberOfLines={5}
                                            />
                                        }
                                        onClickOutside={() => this.hideModal('showEmailsModal')}
                                        isOpen={showEmailsModal}
                                        position={['bottom', 'left', 'right', 'top']}
                                        padding={4}
                                        align={'end'}
                                        contentLocation={mobile ? null : undefined}
                                    >
                                        <Button
                                            icon={'edit-2'}
                                            type={'ghost'}
                                            onPress={() => this.showModal('showEmailsModal')}
                                            disabled={!accessGranted || !loggedUserCanUpdateObject}
                                        />
                                    </AppPopover>
                                </View>
                            </View>

                            {accessGranted && loggedUserCanUpdateObject && (
                                <View style={localStyles.bottomContainer}>
                                    <View style={localStyles.addTaskButton}>
                                        <AppPopover
                                            content={
                                                <RichCreateTaskModal
                                                    initialProjectId={projectId}
                                                    sourceType={FEED_CONTACT_OBJECT_TYPE}
                                                    sourceId={user.uid}
                                                    closeModal={() => this.setState({ showAddTaskModal: false })}
                                                />
                                            }
                                            onClickOutside={() => this.setState({ showAddTaskModal: false })}
                                            isOpen={showAddTaskModal}
                                            padding={4}
                                            position={['top', 'bottom', 'left', 'right']}
                                            align={'end'}
                                            contentLocation={args => popoverToSafePosition(args, mobileNav)}
                                        >
                                            <Button
                                                icon={'check-square'}
                                                title={translate('Add task with this contact')}
                                                type={'ghost'}
                                                onPress={() => this.setState({ showAddTaskModal: true })}
                                                accessible={false}
                                            />
                                        </AppPopover>
                                    </View>
                                    <ObjectRevisionHistory projectId={projectId} noteId={user.noteId} />
                                    <View style={localStyles.deleteButton}>
                                        <Button
                                            icon={'trash-2'}
                                            title={translate('Delete')}
                                            type={'ghost'}
                                            iconColor={colors.UtilityRed200}
                                            titleStyle={{ color: colors.UtilityRed200 }}
                                            buttonStyle={{ borderColor: colors.UtilityRed200, borderWidth: 2 }}
                                            onPress={this.deleteContact}
                                            accessible={false}
                                        />
                                    </View>
                                </View>
                            )}
                        </View>
                    </View>
                </View>
            )
        }

        return null
    }
}

ContactProperties.propTypes = {
    projectIndex: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    project: PropTypes.object.isRequired,
}

const localStyles = StyleSheet.create({
    container: {
        flex: 1,
    },
    profileHeader: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        paddingVertical: 16,
        paddingHorizontal: 8,
        marginBottom: 8,
    },
    profileHeaderMobile: {
        flexDirection: 'column',
        alignItems: 'center',
    },
    profilePhotoContainer: {
        position: 'relative',
        marginRight: 16,
    },
    profilePhoto: {
        width: 120,
        height: 120,
        borderRadius: 60,
    },
    profilePhotoPlaceholder: {
        backgroundColor: colors.Grey200,
        justifyContent: 'center',
        alignItems: 'center',
    },
    profilePhotoEditBadge: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 24,
        height: 24,
        borderRadius: 12,
        backgroundColor: colors.Primary100,
        justifyContent: 'center',
        alignItems: 'center',
    },
    profileInfo: {
        flex: 1,
        justifyContent: 'center',
        minHeight: 120,
    },
    profileActions: {
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'flex-start',
    },
    properties: {
        flexDirection: 'row',
    },
    propertiesMobile: {
        flexDirection: 'column',
    },
    linkedInContainer: {
        paddingVertical: 8,
    },
    linkedInTopRow: {
        height: 40,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
    },
    propertyRow: {
        height: 56,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
    },
    propertyRowSection: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    propertyRowLeft: {
        flex: 1,
        justifyContent: 'flex-start',
    },
    propertyRowRight: {
        justifyContent: 'flex-end',
    },
    bottomContainer: {
        marginTop: 32,
    },
    addTaskButton: {
        flexDirection: 'row',
        paddingVertical: 8,
        justifyContent: 'flex-end',
    },
    deleteButton: {
        flexDirection: 'row',
        paddingVertical: 8,
        justifyContent: 'flex-end',
    },
})

export default ContactProperties
